export default __webpack_public_path__ + "static/iyzico-odeme-6523e4f0287bcd582fac6269a5201f7c.svg";